module.exports = "mutation setToPotential($potentialInput:PotentialInput!){setToPotential(potentialInput:$potentialInput)}"